import { PersonChangeContainer } from "../containers/PersonChangeContainer";

export const CreatePersonPage = () => (
    <PersonChangeContainer type='create'/>
)